import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { DashboardData } from '../../models/dashboard.model';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  dashboardData: DashboardData | null = null;
  isLoading = true;
  hasError = false;
  errorMessage = '';

  constructor(private dashboardService: DashboardService) { }

  ngOnInit(): void {
    this.loadDashboardData();
  }

  /**
   * Carga los datos del dashboard desde el backend
   * Sigue el mismo patrón que el login component
   */
  loadDashboardData(): void {
    this.isLoading = true;
    this.hasError = false;
    this.errorMessage = '';
    
    this.dashboardService.getDashboardData().subscribe({
      next: (data: DashboardData) => {
        this.dashboardData = data;
        this.isLoading = false;
        },
      error: (error) => {
        console.error('Error al cargar datos del dashboard:', error);
        this.isLoading = false;
        this.hasError = true;
        
        // Manejo de errores específicos como en AuthService
        if (error.status === 401) {
          this.errorMessage = 'No tienes permisos para acceder al dashboard. Inicia sesión como administrador.';
        } else if (error.status === 422) {
          this.errorMessage = 'Error de autenticación. Verifica que hayas iniciado sesión correctamente.';
        } else if (error.status === 0) {
          this.errorMessage = 'No se puede conectar con el servidor. Verifica tu conexión.';
        } else {
          this.errorMessage = 'Error al cargar los datos del dashboard. Inténtalo de nuevo.';
        }
      }
    });
  }

  /**
   * Reintenta cargar los datos del dashboard
   */
  retryLoadData(): void {
    this.loadDashboardData();
  }
}
